import translate from '@translate';
import React, { FC } from 'react';
import Grid, { GridItem } from 'src/components/Grid';
import Select from 'src/components/Select';
import TextField from 'src/components/TextField';
import { TransportType } from 'src/types/transport';
import { ConstantsCodeType } from 'src/types/constantsCodes';
import { Typography } from '@mui/material';
import Switch from 'src/components/Switch';
import PaymentEdit, { PaidActionOptionType } from 'src/components/PaymentEdit';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { EditKeysType } from './constants';

export interface InvoicePropsType {
    onChange: OnChangeType<EditKeysType>;
    editData: TransportType;
    editErrors: FormErrorsType;
    disableEdit: boolean;
    permissionEditAll: boolean;
    currencyCodes: ConstantsCodeType[];
    paymentCodes: ConstantsCodeType[];
    handlePaidTransport: (paidOption: PaidActionOptionType) => void;
    summary?: boolean;
}

const Invoice: FC<InvoicePropsType> = (props) => {
    return (
        <Grid>
            <GridItem cols={12}>
                <Typography variant="h3" gutterBottom>
                    {translate('transportDetail.invoice')}
                </Typography>
            </GridItem>
            <GridItem cols={4}>
                <TextField
                    value={props.editData.PRICE}
                    error={props.editErrors.PRICE}
                    onChange={(value, error) => props.onChange('PRICE', value, error)}
                    name="PRICE"
                    label={translate('transportDetail.invoicePrice')}
                    fullWidth
                    required
                    type="numberLocale"
                    min={0}
                    disabled={props.disableEdit || props.summary}
                />
            </GridItem>
            <GridItem cols={2}>
                <Select
                    options={props.currencyCodes}
                    value={props.editData.CURRENCY}
                    error={props.editErrors.CURRENCY}
                    onChange={(value, error) => props.onChange('CURRENCY', value, error)}
                    name="CURRENCY"
                    label={translate('transportDetail.currency')}
                    fullWidth
                    required
                    disabled={props.disableEdit || props.summary}
                />
            </GridItem>
            <GridItem cols={4}>
                <TextField
                    value={props.editData.SHIPPING_PRICE}
                    error={props.editErrors.SHIPPING_PRICE}
                    onChange={(value, error) => props.onChange('SHIPPING_PRICE', value, error)}
                    name="SHIPPING_PRICE"
                    label={translate('transportDetail.shippingPrice')}
                    fullWidth
                    required
                    type="numberLocale"
                    min={0}
                    disabled={props.disableEdit || props.summary}
                />
            </GridItem>
            <GridItem cols={2}>
                <Select
                    options={props.currencyCodes}
                    value={props.editData.SHIPPING_CURRENCY}
                    error={props.editErrors.SHIPPING_CURRENCY}
                    onChange={(value, error) => props.onChange('SHIPPING_CURRENCY', value, error)}
                    name="SHIPPING_CURRENCY"
                    label={translate('transportDetail.shippingPriceCurrency')}
                    fullWidth
                    required
                    disabled={props.disableEdit || props.summary}
                />
            </GridItem>
            <GridItem cols={6}>
                <TextField
                    value={props.editData.INVOICE_NUMBER}
                    error={props.editErrors.INVOICE_NUMBER}
                    onChange={(value, error) => props.onChange('INVOICE_NUMBER', value, error)}
                    name="INVOICE_NUMBER"
                    label={translate('transportDetail.invoiceNumber')}
                    fullWidth
                    disabled={props.disableEdit || props.summary}
                />
            </GridItem>
            <GridItem cols={6}>
                <PaymentEdit
                    value={props.editData.PAYMENT_METHOD}
                    error={props.editErrors.PAYMENT_METHOD}
                    disabled={!props.permissionEditAll || !!props.summary}
                    disablePaidActions={props.disableEdit || !!props.summary}
                    onChange={(value, error) => props.onChange('PAYMENT_METHOD', value, error)}
                    handlePaidAction={props.handlePaidTransport}
                    paymentCodes={props.paymentCodes}
                />
            </GridItem>
            <GridItem cols={4}>
                {props.editData.PAYMENT_METHOD === '0' && (
                    <TextField
                        value={props.editData.COD_PRICE}
                        error={props.editErrors.COD_PRICE}
                        onChange={(value, error) => props.onChange('COD_PRICE', value, error)}
                        name="COD_PRICE"
                        label={translate('transportDetail.cashOnDeliveryPrice')}
                        fullWidth
                        required
                        type="numberLocale"
                        min={0}
                        disabled={props.disableEdit || props.summary}
                    />
                )}
            </GridItem>
            <GridItem cols={2}>
                {props.editData.PAYMENT_METHOD === '0' && (
                    <Select
                        options={props.currencyCodes}
                        value={props.editData.COD_CURRENCY}
                        error={props.editErrors.COD_CURRENCY}
                        onChange={(value, error) => props.onChange('COD_CURRENCY', value, error)}
                        name="COD_CURRENCY"
                        label={translate('transportDetail.cashOnDeliveryCurrency')}
                        fullWidth
                        required
                        disabled={props.disableEdit || props.summary}
                    />
                )}
            </GridItem>
            <GridItem cols={6}>
                {props.editData.PAYMENT_METHOD === '0' && (
                    <TextField
                        value={props.editData.COD_REF_NUMBER}
                        error={props.editErrors.COD_REF_NUMBER}
                        onChange={(value, error) => props.onChange('COD_REF_NUMBER', value, error)}
                        name="COD_REF_NUMBER"
                        label={translate('transportDetail.cashOnDeliveryRefNumber')}
                        fullWidth
                        required
                        disabled={props.disableEdit || props.summary}
                    />
                )}
            </GridItem>
            <GridItem cols={6}>
                <Switch
                    value={!!props.editData.PAID}
                    onChange={(value) => props.onChange('PAID', value ? 1 : 0, false)}
                    disabled={!props.permissionEditAll || props.summary}
                    label={translate('transportDetail.paid')}
                />
            </GridItem>
            <GridItem cols={6}>
                <Switch
                    value={!!props.editData.AGECHECK}
                    onChange={(value) => props.onChange('AGECHECK', value ? 1 : 0, false)}
                    disabled={props.disableEdit || props.summary}
                    label={translate('transportDetail.agecheck')}
                />
            </GridItem>
        </Grid>
    );
};

export default Invoice;
